//import { load as loadRecaptcha } from "recaptcha-v3";
import "./style.css";


export default class RegistrationBlock {
  static selector = ".contact-us__form.registration-form__form";

  constructor(block) {
    this.block = block;

    /*
    this.form = block.querySelector(".contact-us__form.registration-form");

    // radio field
    const choiceRadio = this.form.querySelectorAll(
      ".contact-us__form .choice input[type=radio]"
    );
    for (const input of choiceRadio) {
      input.addEventListener("input", this.getOnInput(choiceRadio));
    }

    this.form.addEventListener("input", this.onInputForm);
    this.form.addEventListener("invalid", this.onInvalidForm, true);

    this.submitButton = this.form.querySelector("button");
    this.submitButton.addEventListener("click", this.onSubmitButtonClick);

    // implement recaptcha
    this.recaptchaSiteKey = this.form.dataset.recaptcha;
    this.recaptchaResponseInput = this.form.querySelector(
      "input[name=recaptchaResponse]"
    );

    this.isRecaptcha = !!this.recaptchaSiteKey && !!this.recaptchaResponseInput;

    

    // Add More field
    this.showmoreField = this.block.querySelectorAll(".morefield");
    for (const button of this.showmoreButtons) {
      button.addEventListener("click", this.showmoreField);
    }
    */
  }

  /*
  onSubmitButtonClick = (e) => {
    e.preventDefault();
    this.submitButton.classList.toggle("disabled", true);
    this.sendForm();
  };

  getOnInput = (inputs) => {
    return (e) => {
      const currentInput = e.currentTarget;

      const allowMultiple = currentInput.type === "checkbox";
      const required = !!(currentInput.type === "checkbox"
        ? currentInput.checked
        : currentInput.value.length);

      for (const input of inputs) {
        input.required = !required;
        input.disabled = !allowMultiple && required;
        this.setValidity(input.parentNode, true);
      }

      currentInput.required = required;
      currentInput.disabled = !allowMultiple && !required;
    };
  };

  setStatus = (success, message) => {
    const status = this.form.querySelector(".contact-us__form__status");
    const info = status.querySelector(".contact-us__form__status__message");
    const sentMessage = document.getElementById("message_div");
    //const sentMessage = this.form.querySelector(".sentMessage");
    sentMessage.style.display = "block";
    //status.classList.add(success ? "sent" : "failed");
    sentMessage.classList.remove("success_message");
    sentMessage.classList.remove("failed_message");
    if (success) {
      sentMessage.classList.add("success_message");
      this.form.reset();
    } else {
      sentMessage.classList.add("failed_message");
    }
    document.getElementById("message_content").innerHTML = message;
    setTimeout(function () {
      sentMessage.style.display = "none";
    }, 10000);
  };

  setValidity = (block, valid) => {
    const input = block.querySelector("input");
    const error = block.querySelector(".error-message");

    const errorClass = "error";
    const emptyFieldMessage = window.saee.copy["You have to fill this field"];
    const defaultErrorMessage = window.saee.copy["Invalid field"];

    let errorMessage = input.validationMessage || defaultErrorMessage;

    if (!input.value.trim()) {
      errorMessage = emptyFieldMessage;
    }

    block.classList.remove(errorClass);
    if (!valid) {
      block.classList.add(errorClass);
    }

    if (error) {
      error.textContent = errorMessage;
    }
  };

  onInputForm = async (e) => {
    e.preventDefault();
    this.setValidity(e.target.parentNode, true);
  };

  onInvalidForm = async (e) => {
    e.preventDefault();
    this.setValidity(e.target.parentNode, false);
  };
  

  onShowMoreField = (e) => {
    e.preventDefault();

    alert('test');
  };

  */
}
